import React, { useState } from "react";
import { Tabs, Tab, Box, Button } from "@mui/material";
import MemberDetailPage from "./MemberDetailPage";
import MembersTable from "./MembersTable/MembersTable";
import AddMemberModal from "../../components/AddMemberModal/AddMemberModal";

interface Member {
  codename: string;
  gender: string;
  dob: string;
  member_status: string;
}

// Updated interface to include onShowSnackbar
export interface MembersTabsProps {
  onOpenAddMemberModal: () => void;
  members: Member[];
  refreshMembers: () => void;
  onShowSnackbar: (message: string, severity: "success" | "error") => void;
}

const MembersTabs: React.FC<MembersTabsProps> = ({
  onOpenAddMemberModal,
  members,
  refreshMembers,
  onShowSnackbar,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedMember, setSelectedMember] = useState<Member | null>(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const filterMembers = (status: string) => {
    return members.filter((member) => member.member_status === status);
  };

  const handleMemberClick = (member: Member) => {
    setSelectedMember(member);
  };

  const handleGoBack = () => {
    setSelectedMember(null);
  };

  const handleOpenModal = () => {
    setIsAddModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsAddModalOpen(false);
  };

  const handleMemberAdded = () => {
    refreshMembers();
  };

  return (
    <Box sx={{ width: "100%" }}>
      {!selectedMember && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              backgroundColor: "#F4F2FF",
              borderRadius: ".5cm",
              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start",
              },
            }}
          >
            <Tab label="Approved" />
            <Tab label="Pending" />
            <Tab label="Denied" />
          </Tabs>
          <Button
            variant="contained"
            onClick={handleOpenModal}
            sx={{
              bgcolor: "#5958e1",
              "&:hover": { bgcolor: "#4a49b3" },
            }}
          >
            Add Participant
          </Button>
        </Box>
      )}

      {selectedMember ? (
        <MemberDetailPage
          member={selectedMember}
          goBack={handleGoBack}
          refreshMembers={refreshMembers}
        />
      ) : (
        <Box>
          {activeTab === 0 && (
            <MembersTable
              members={filterMembers("approved")}
              onMemberClick={handleMemberClick}
            />
          )}
          {activeTab === 1 && (
            <MembersTable
              members={filterMembers("pending")}
              onMemberClick={handleMemberClick}
            />
          )}
          {activeTab === 2 && (
            <MembersTable
              members={filterMembers("denied")}
              onMemberClick={handleMemberClick}
            />
          )}
        </Box>
      )}

      <AddMemberModal
        open={isAddModalOpen}
        onClose={handleCloseModal}
        onMemberAdded={handleMemberAdded}
        onShowSnackbar={onShowSnackbar}
      />
    </Box>
  );
};

export default MembersTabs;
